export { GAME_W, GAME_H, FPS } from "shared/config";

export const LAYER_BG = 5;
export const LAYER_GROUND = 4;
export const LAYER_ENEMY = 3;
export const LAYER_FX = 2;
export const LAYER_HERO = 1;
export const LAYER_GUI = 0;

export const DRAWING_MODE_SINGLE = "single";
export const DRAWING_MODE_DOUBLE = "double";

export const COPTER_SPRITE_W = 12;
export const COPTER_SPRITE_H = 10;
export const COPTER_FRAMES = 5;
export const COPTER_X_RATIO = 0.3;

export const GRAVITY = 180;
export const LIFT = -315;
export const MAX_VY_UP = 60;
export const MAX_VY_DOWN = 75;
export const COPTER_ANGLE_FACTOR = 1 / 2;

export const PIECE_WIDTH = 1280;
export const INIT_SPEED = 90;
export const MAX_SPEED = 300;

export const TOTAL_DISTANCE = 8000;
export const ACCEL_AMOUNT = 20;
export const ACCEL_LIMIT = 300;

export const COIN_INTERVAL = 8;
export const TURRET_INTERVAL = 60;
export const BIRD_INTERVAL = 40;
export const PICKUP_INTERVAL = 200;
export const BONUS_LAYOUT_INTERVAL = 60;

export const GOD_MODE_DURATION = 2.7;
export const SMALL_EXPLOSION_COUNT = 25;
export const BIG_EXPLOSION_COUNT = 80;
export const DAMAGE_HOLE_RADIUS = 10;
export const DEATH_HOLE_RADIUS = 15;
export const BULLET_HOLE_RADIUS = 5;

export const BULLET_SPEED = 120;
export const BULLET_GRAVITY = 90;

export const TURRET_FIRE_INTERVAL = 0.3;
export const TURRET_GUN_LENGTH = 8;
export const TURRET_CENTER_X = 4;
export const TURRET_CENTER_Y = 2;

export const BIRD_SPRITE_W = 3;
export const BIRD_SPRITE_H = 3;
export const BIRD_COUNT = 3;
export const BIRD_FORMATION = [1, -1, 1];
export const BIRD_Y_MIN = 0;
export const BIRD_Y_MAX = 3;
export const BIRD_WAVE_INTERVAL = 6;

export const BONUS_TOP = 0.2;
export const BONUS_MIDDLE = 0.5;
export const BONUS_BOTTOM = 0.8;

export const CELL_W = 2;
export const CELL_H = 2;
export const SPACE_X = 1;
export const SPACE_Y = 1;
export const NORMAL_GRAIN = 0;
export const HITTED_GRAIN = 0.2;
export const DEFAULT_MOTION_BLUR_ALPHA = 0.8;
export const GRID_ALPHA = 0.1;

export const CURTAIN_CLOSE_DELAY = 1;
export const CURTAIN_OPEN_DELAY = 0.67;
export const CURTAIN_WAIT_FRAMES = 0.17;

export const HEART_W = 7;
export const HEART_H = 7;
export const HUD_HEIGHT = 10;
export const PROGRESS_BAR_W = 40;
export const PROGRESS_BAR_H = 3;

export const MAX_LIVES = 3;
export const MAX_HEART_SLOTS = 5;

export const TERRAIN_COSINE_SEGMENTS = 8;
export const TERRAIN_COSINE_ROUGHNESS = 10;

export const TERRAIN_FRACTAL_ROUGHNESS = 5;
export const TERRAIN_FRACTAL_REDUCTION = 0.6;

export const TERRAIN_MULTISINE_STEPS = 100;
export const TERRAIN_MULTISINE_WAVELENGTH = 0.3;
export const TERRAIN_MULTISINE_AMPLITUDE = 0.5;
export const TERRAIN_MULTISINE_OCTAVES = 4;

export const TERRAIN_COSINE = "cosine";
export const TERRAIN_FRACTAL = "fractal";
export const TERRAIN_MULTISINE = "multisine";
export const TERRAIN_PERLIN = "perlin";
